import React, { useCallback } from "react"
import * as AppConstants from "@/utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"

function TabGestioneExtra(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE

    return (
        <React.Fragment>
            {/*    
                <tr>
                    <th className="th_punteggio_isa"> {AppConstants.TITLE_FREQUENZA_1} {AppConstants.TITLE_FREQUENZA_2}</th>
                    {props.isCampo1 ? <td>{props.campo1 !== undefined ? props.campo1.anomaliaGexcNum : elemNonDisponibile}</td> : <React.Fragment />}
                    {props.isCampo2 ? <td> {props.campo2 !== undefined ? props.campo2.anomaliaGexcNum : elemNonDisponibile} </td> : <React.Fragment />}
                    <td>{props.campo3 !== undefined ? props.campo3.anomaliaGexcNum : elemNonDisponibile}</td>
                    <td>{props.campo4 !== undefined ? props.campo4.anomaliaGexcNum : elemNonDisponibile}</td>
                    {props.isCampo5 ? <td>{props.campo5 !== undefined ? props.campo5.anomaliaGexcNum : elemNonDisponibile}</td> : <React.Fragment />}
                </tr>
                */}
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.TITLE_FREQUENZA_1}{" "}
                    {AppConstants.TITLE_FREQUENZA_5}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ?props.campo1.anomaliaGexc11Num
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaGexc11Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.anomaliaGexc11Num
                        : elemNonDisponibile}
                </td>
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.TITLE_FREQUENZA_1}{" "}
                    {AppConstants.TITLE_FREQUENZA_3}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaGexc15Num
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaGexc15Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.anomaliaGexc15Num
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
           
        </React.Fragment>
    )
}
export default TabGestioneExtra
